import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Order } from '../models/order';
import { httpClient, orderStorage } from '../shop/shop-context';

export class OrderService {
	private _url = 'connect/order';

	constructor() {}

	get(partnerIds: string): Observable<Order[]> {
		return orderStorage.getOpenedOrders().pipe(
			switchMap(orders => {
				if (orders) {
					return of(orders);
				} else {
					const url = `/${this._url}?partnerIds=${partnerIds}`;
					return httpClient.get<Order[]>(url).pipe(map(orders => orders));
				}
			})
		);
	}

	getArchive(partnerIds: string): Observable<Order[]> {
		return orderStorage.getArchivedOrders().pipe(
			switchMap(orders => {
				if (orders) {
					return of(orders);
				} else {
					const url = `/${this._url}/archive?partnerIds=${partnerIds}`;
					return httpClient.get<Order[]>(url).pipe(map(orders => orders));
				}
			})
		);
	}

	getRecommandations(partnerIds: string): Observable<string> {
		const url = `/${this._url}/recommendations?partnerIds=${partnerIds}`;
		return httpClient.get<string>(url);
	}

	getLastOrderedProducts(partnerIds): Observable<string> {
		const url = `/${this._url}/getLastOrderedProducts?partnerIds=${partnerIds}`;

		return httpClient.get<string>(url);
	}

	getLastOrderedProductsPaged(page: number, pageSize: number, contentId: number, displayType: string, sort: string): Observable<string> {
		const url = `/${this._url}/getLastOrderedProductsPaged?page=${page}&pageSize=${pageSize}&contentId=${contentId}&displayType=${displayType}&sort=${sort}`;
		return httpClient.get<string>(url);
	}

	getOrderDetail(orderId: string, type: string): Observable<string> {
		const url = `/${this._url}/getOrderDetail?id=${orderId}&type=${type}`;
		return httpClient.get<string>(url);
	}
}
